export default __webpack_public_path__ + "static/media/about-us.a4272c14.svg";